import { TypedWorker } from "./typedWorker";
import FileCacheWorker from "../workers/fileCache?worker";

export const fileCacheWorker = new TypedWorker(new FileCacheWorker());
